import React from 'react';
import Button from '../../../../../components/Button';
import Select from '../../../../../components/input/Select/Select';
import Anchor from '../../../../../components/link/Anchor';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import OpenCsInquiryQuestion from '../../../../../containers/cs/inquiry/common/OpenCsInquiryQuestion';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { CS_INQUIRY_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import {
  CS_INQUIRY_RESPONSE_STATUS_SELECT_LIST,
  CS_INQUIRY_RESPONSE_STATUS_TEXT,
  CS_INQUIRY_TYPE_SELECT_LIST,
  CS_INQUIRY_TYPE_TEXT,
  PLACEHOLDER_TEXT_INQUIRY_CREATE_DATE,
} from '../../../../../constants/service/app/csInquiryConstants';
import { reDirectPage, setColumnWidth, setDash, setDetailPageUrl } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  1:1 문의 리스트 컬럼
 */
const columns = (data) => {
  const { list, filterOption, onFilter } = data;

  return [
    {
      accessor: 'isResponse',
      Header: '답변 처리',
      filterable: true,
      fixed: 'left',
      width: 120,
      Cell: (row) => (
        <Button
          isRadius
          color={row.value ? 'primary' : 'red'}
          text={CS_INQUIRY_RESPONSE_STATUS_TEXT[row.value]}
          onClick={() => reDirectPage({ path: setDetailPageUrl(CS_INQUIRY_DETAIL_URL_PATH, row.original.id) })}
        />
      ),
      Filter: () => (
        <Select
          list={CS_INQUIRY_RESPONSE_STATUS_SELECT_LIST}
          onChange={(isResponse) => onFilter({ isResponse })}
          defaultValue={filterOption.isResponse}
          value={filterOption.isResponse}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'id',
      Header: '1:1 문의 ID',
      filterable: true,
      fixed: 'left',
      Cell: (row) => (
        <Anchor
          text={row.value}
          isUnderLine
          color="primary"
          href={setDetailPageUrl(CS_INQUIRY_DETAIL_URL_PATH, row.value)}
          target="_blank"
        />
      ),
      Filter: () => (
        <TableFilterInput option={filterOption.inquiryId} onFilter={(inquiryId) => onFilter({ inquiryId })} />
      ),
    },
    {
      accessor: 'type',
      Header: '질문 유형',
      filterable: true,
      fixed: 'left',
      width: 170,
      Cell: (row) => CS_INQUIRY_TYPE_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={CS_INQUIRY_TYPE_SELECT_LIST}
          onChange={(type) => onFilter({ type })}
          defaultValue={filterOption.type}
          value={filterOption.type}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'url',
      Header: '이미지',
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'question',
      Header: '질문 내용',
      className: 'align-left',
      width: 200,
      filterable: true,
      resizable: true,
      Cell: (row) => (
        <OpenCsInquiryQuestion
          text={row.value}
          question={row.value}
          answer={row.original.answer}
          memo={row.original.memo}
        />
      ),
      Filter: () => <TableFilterInput option={filterOption.question} onFilter={(question) => onFilter({ question })} />,
    },
    {
      accessor: 'answer',
      Header: '답변 내용',
      className: 'align-left',
      width: 200,
      filterable: true,
      resizable: true,
      Cell: (row) => (
        <OpenCsInquiryQuestion
          text={row.value}
          question={row.original.question}
          answer={row.value}
          memo={row.original.memo}
        />
      ),
      Filter: () => <TableFilterInput option={filterOption.answer} onFilter={(answer) => onFilter({ answer })} />,
    },
    {
      accessor: 'replyAuthor',
      Header: '답변 작성자',
      filterable: true,
      width: setColumnWidth(list, 'replyAuthor'),
      Cell: (row) => setDash(row.value),
      Filter: () => (
        <TableFilterInput option={filterOption.replyAuthor} onFilter={(replyAuthor) => onFilter({ replyAuthor })} />
      ),
    },
    {
      accessor: 'memo',
      Header: '답변 작성자 메모',
      className: 'align-left',
      filterable: true,
      resizable: true,
      width: 200,
      Cell: (row) => (
        <OpenCsInquiryQuestion
          text={row.value}
          question={row.original.question}
          answer={row.original.answer}
          memo={row.value}
        />
      ),
      Filter: () => <TableFilterInput option={filterOption.memo} onFilter={(memo) => onFilter({ memo })} />,
    },
    {
      id: 'answerDate',
      accessor: 'answerDate',
      Header: '답변 일자',
      sortable: true,
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.answerDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ answerDate: data })}
        />
      ),
    },
    {
      id: 'createDate',
      accessor: 'createDate',
      Header: '질문 작성 일자',
      sortable: true,
      filterable: true,
      width: 340,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.FULL_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          showTime={true}
          btnTextFormat={DATE_FORMAT.FULL_DASH_FORMAT}
          startText={PLACEHOLDER_TEXT_INQUIRY_CREATE_DATE}
          endText={PLACEHOLDER_TEXT_INQUIRY_CREATE_DATE}
          outFormat={DATE_FORMAT.FULL_DASH_FORMAT}
          format={DATE_FORMAT.FULL_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
  ];
};

export default columns;
